import { Modal } from './modal';

export { Modal };
